import React, { useState, useEffect, useContext } from "react";
import { AgGridColumn, AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import {
  Row,
  Col,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import Switch from "react-switch";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  AssesmentMaster,
  EMPTY_DATA,
  defaultPageSize,
} from "../../../config/constants";
import NoContentFound from "../../common/NoContentFound";
import PopupMsgWrapper from "../../common/PopupMsgWrapper";
import { PaginationWrapper } from "../../common/commonPagination";
import Toaster from "../../common/Toaster";
import LoaderCustom from "../../common/LoaderCustom";
import {
  handleDepartmentHeader,
  searchNocontentFilter,
  setLoremIpsum,
  userDetails,
} from "../../../helper";
import { ApplyAssesmentMaster } from ".";
import CustomDateRangeFilter from "../supplierNewRequestHistory/common/CustomDateRangeFilter ";
import { fetchAssesmentMasterListing, getDeletQuestion } from "./Action";
import _ from "lodash";
import ReactExport from "react-export-excel";
import { Asssesment_Master_Excel } from "../../../config/masterData";
import AddQuestion from "./AddQuestion/AddQuestion";
import ReviewAssesmentQuestions from "./ReviewAssesmentQuestions";
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
const gridOptions = {};

const AssesmentMasterListing = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [showPopup, setShowPopup] = useState(false);
  const permissionAssesment = useContext(ApplyAssesmentMaster);
  const [pageNo, setPageNo] = useState(1);
  const [noData, setNoData] = useState(false);
  const [loader, setloader] = useState(false);
  const [addQuestionTab, setQuestionTab] = useState(false)
  const [addQuestionTabGuid, setQuestionTabGuid] = useState(null)
  const [activeTab, setActiveTab] = useState("main");
  const [state, setState] = useState({
    isEditFlag: false,
    isOpenVendor: false,
    shown: false,
    ID: "",
    tableData: [],
    city: [],
    country: [],
    state: [],
    showPopup: false,
    deletedId: "",
    cellData: {},
    cellValue: "",
    showPopupToggle: false,
    isViewMode: false,
    isLoader: false,
    selectedRowData: false,
    noData: false,
    dataCount: 0,
    type: "",
    render: false,
    showExtraData: false,
  });
  const [deletedId, setDeletedID] = useState(null);
  const [currentRowIndex, setCurrentRowIndex] = useState(0);
  const handleDropdownItemClick = (action) => {
    // Add your logic here for handling dropdown item clicks
    // For example, you might want to update the "Last clicked" text
  };
  const { AssesmentMasterList } = useSelector(
    (state) => state?.AssesmentMasterList
  );
  const getUsers = async (currentPage, pageSize, sortOrder, fieldName) => {
    try {
      const userDetail = userDetails();
      // Set loader to true to indicate data fetching
      setloader(true);
      // Dispatch the action to fetch users
      await dispatch(
        fetchAssesmentMasterListing({
          current_page: currentPage,
          per_page: pageSize,
          EmployeeId: userDetail?.EmployeeId,
          sortOrder: sortOrder,
          sortField: fieldName,
          //   requestFromDate: requestFromDate,
          //   requestToDate: requestToDate,
        })
      );
      // Reset loader to false after the data is fetched
      setloader(false);
    } catch (error) {
      // Handle errors, e.g., display an error message
      console.error("Error fetching users:", error);
      // Reset loader to false in case of an error
      setloader(false);
    }
  };

  useEffect(() => {
    // Function to fetch data after a 3-second delay
    const fetchDataWithDelay = async () => {
      // Show loader
      setloader(true);

      // Simulate loading for 3 seconds
      await new Promise((resolve) => setTimeout(resolve, 3000));

      try {
        // Fetch data after the delay
        await getUsers(pageNo, defaultPageSize, "ASC");
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        // Hide loader after fetching data or encountering an error
        setloader(false);
      }
    };

    // Call fetchDataWithDelay function
    fetchDataWithDelay();
  }, []);


  /**
   * @method onFloatingFilterChanged
   * @description Filter data when user type in searching input
   */
  const onFloatingFilterChanged = (value) => {
    setTimeout(() => {
      if (AssesmentMasterList?.data?.Data.length !== 0) {
        setState((prevState) => ({
          ...prevState,
          noData: searchNocontentFilter(value, prevState.noData),
        }));
      }
    }, 500);
  };
  const isFirstColumn = (params) => {
    var displayedColumns = params.columnApi.getAllDisplayedColumns();
    var thisIsFirstColumn = displayedColumns[0] === params.column;
    return thisIsFirstColumn;
  };
  const defaultColDef = {
    resizable: true,
    filter: true,
    sortable: false,
    headerCheckboxSelectionFilteredOnly: true,
    checkboxSelection: isFirstColumn,
  };
  const onRowSelect = () => {
    const selectedRows = state.gridApi?.getSelectedRows();
    setState((prevState) => ({
      ...prevState,
      selectedRowData: selectedRows,
      dataCount: selectedRows.length,
    }));
  };
  const resetState = () => {
    const searchBox = document.getElementById("filter-text-box");
    if (searchBox) {
      searchBox.value = "";
    }
    state.gridApi.setQuickFilter(null);
    state.gridApi.deselectAll();
    state.gridApi.setFilterModel(null);
    state.gridColumnApi.resetColumnState();
    setState((prevState) => ({ ...prevState, noData: false }));
  };
  const onBtExport = () => {
    let tempArr = state.gridApi && state.gridApi.getSelectedRows();
    tempArr =
      tempArr && tempArr.length > 0
        ? tempArr
        : AssesmentMasterList?.data?.Data
          ? AssesmentMasterList?.data?.Data
          : [];
    return returnExcelColumn(Asssesment_Master_Excel, tempArr);
  };

  const returnExcelColumn = (data = [], TempData) => {

    return (
      <ExcelSheet data={TempData} name={AssesmentMaster}>
        {data &&
          data.map((ele, index) => (
            <ExcelColumn
              key={index}
              label={
                ele.label === "Company Name"
                  ? `${handleDepartmentHeader()} Name`
                  : ele.label
              }
              value={ele.value}
              style={ele.style}
            />
          ))}
      </ExcelSheet>
    );
  };

  const onGridReady = (params) => {
    window.screen.width >= 1300 && params.api.sizeColumnsToFit();
    setState((prevState) => ({
      ...prevState,
      gridApi: params.api,
      gridColumnApi: params.columnApi,
    }));
    params.api.paginationGoToPage(0);
  };
  const onPageSizeChanged = (newPageSize) => {
    state.gridApi.paginationSetPageSize(Number(newPageSize));
  };
  const renderCategoryCount = (params) => {
    const categories = params.value;
    const categoryCount = categories.length;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [dropdownOpen, setDropdownOpen] = useState(false);

    const toggleDropdown = () => setDropdownOpen((prevState) => !prevState);

    if (categoryCount === 0) {
      return <span>No categories</span>;
    }

    if (categoryCount === 1) {
      return <span>{categories[0].CategoryName}</span>;
    }

    const formattedCategories = categories.map(
      (category) => category.CategoryName
    );
    const visibleCategories = formattedCategories.slice(0, 1); // Show only the first category
    const hiddenCategories = formattedCategories.slice(1); // Hide the first category, rest will go in dropdown

    return (
      <div className="hl-category-count">
        <span className="hl-category-names">{visibleCategories}</span>
        <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
          <DropdownToggle caret={false} className="hl-category-count-btn">
            +{categoryCount - 1} more
          </DropdownToggle>
          <DropdownMenu container="body" className="hl-cat-menu">
            {hiddenCategories.map((category, index) => (
              <DropdownItem
                key={index}
                className="hl-cat-menu-item"
                onClick={() => handleDropdownItemClick(category)}
              >
                {category}
              </DropdownItem>
            ))}
          </DropdownMenu>
        </Dropdown>
      </div>
    );
  };
  // export default renderCategoryCount;
  const closePopUp = () => {
    setShowPopup(false);
  };
  const handleDelete = () => {
    setShowPopup(false);
    handleDeleteBusinessType(deletedId);
  };

  const handleDeleteBusinessType = (quesId) => {
    getDeletQuestion(quesId, (error, response) => {
      if (error) {
        console.error("Error deleting question:", error);
        // Handle the error as needed
      } else {
        Toaster.success(response?.data?.Data?.Message);
        // Fetch updated data after deletion
        setloader(true); // Set loader to indicate data fetching
        getUsers(pageNo, defaultPageSize, "ASC"); // Fetch updated data
      }
    });
  };

  const buttonFormatter = (props) => {
    props.api.sizeColumnsToFit();
    const handleAccept = () => {
      setActiveTab("edit")
      setQuestionTab(props?.data?.QuestionID)
      setQuestionTabGuid(props?.data?.ItemGuid)
      // history.push(
      //   `/add-question?questionId=${props?.data?.QuestionID}&mode=edit`
      // );
    };
    const handleDelete = () => {
      setShowPopup(true);
      setDeletedID(props?.data?.ItemGuid);
    };
    return (
      <div>
        {permissionAssesment?.Edit && (
          <button
            title="Edit"
            className="Edit hl-accept-icon mr-2"
            type="button"
            onClick={handleAccept}
          >
            {/* Edit */}
          </button>
        )}
        {permissionAssesment?.Delete && (
          <button
            title="Delete"
            className="Delete hl-delete-icon"
            type="button"
            onClick={handleDelete}
          >
            {/* Delete */}
          </button>
        )}
      </div>
    );
  };
  const statusButtonFormatter = (cell, row, enumObject, rowIndex) => {
    return (
      <>
        <label htmlFor="normal-switch" className="normal-switch">
          <Switch
            // onChange={() => handleChange(cell, row, enumObject, rowIndex)}
            checked={cell}
            background="#ff6600"
            onColor="#4DC771"
            onHandleColor="#ffffff"
            id="normal-switch"
            height={24}
          />
        </label>
      </>
    );
  };

  /**
   * @method effectiveDateFormatter
   * @description Renders buttons
   */

  const frameworkComponents = {
    totalValueRenderer: buttonFormatter,
    customFloatingFilter: CustomDateRangeFilter,
    statusButtonFormatter: statusButtonFormatter,
    // hyphenFormatter: hyphenFormatter,
    customNoRowsOverlay: NoContentFound,
    renderCategoryCount: renderCategoryCount,
    // valuesFloatingFilter: SingleDropdownFloationFilter,
  };
  /**
   * @method statusButtonFormatter
   * @description Renders buttons
   */

  return (
    <>
      {activeTab === "main" ? (
        <>
          {loader && <LoaderCustom customClass="simulation-Loader" />}
          {showPopup && (
            <PopupMsgWrapper
              isOpen={showPopup}
              closePopUp={closePopUp}
              confirmPopup={handleDelete}
              message="Are you sure you want to delete this item?"
            />
          )}
          <Row className="ag-grid-react">
            <Col>
              <div
                className={`ag-grid-wrapper ${props?.isDataInMaster && !noData ? "master-approval-overlay" : ""
                  } ${(AssesmentMasterList?.data?.Data &&
                    AssesmentMasterList?.data?.Data?.length <= 0) || noData
                    ? "overlay-contain"
                    : ""
                  }`}
              >
                <div
                  className={`hl-self-assessment-table ${loader && "max-loader-height"
                    }`}
                >
                  {noData && (
                    <NoContentFound
                      title={EMPTY_DATA}
                      customClassName="no-content-found"
                    />
                  )}
                  <Row className="filter-row-large">
                    <Col md="12" className="mb-3 d-flex justify-content-end">
                      <div className="d-flex justify-content-end bd-highlight w100">
                        {permissionAssesment?.Add && (
                          <button
                            type="button"
                            className="user-btn mr5"
                            title="Add New Question"
                            onClick={() => {
                              setActiveTab("add");
                            }}
                          >
                            <div className="plus mr-0"></div>
                          </button>
                        )}
                        {permissionAssesment?.View && (
                          <button
                            type="button"
                            className="user-btn m-0 mr5"
                            title="Review Questionnaire"
                            onClick={() => {
                              setActiveTab("review");
                            }}
                          ><i class="fa-solid fa-magnifying-glass mr-1"></i> All</button>
                        )}
                        <ExcelFile
                          filename={AssesmentMaster}
                          fileExtension=".xls"
                          element={
                            <button
                              title={`Download ${state.dataCount === 0 ? "All" : `(${state.dataCount})`
                                }`}
                              type="button"
                              className="user-btn mr5 Tour_List_Download"
                            >
                              <div className="download mr-1"></div>
                              {state.dataCount === 0 ? "All" : `(${state.dataCount})`}
                            </button>
                          }
                        >
                          {onBtExport()}
                        </ExcelFile>
                      </div>
                      <button
                        type="button"
                        className="user-btn Tour_List_Reset"
                        title="Reset Grid"
                        onClick={() => resetState()}
                      >
                        <div className="refresh mr-0"></div>
                      </button>
                    </Col>
                  </Row>
                  <div
                    className={`ag-theme-material ${state.isLoader && "max-loader-height"
                      }`}
                  >
                    {state.noData && (
                      <NoContentFound
                        title={EMPTY_DATA}
                        customClassName="no-content-found"
                      />
                    )}
                    {state.isLoader ? (
                      <LoaderCustom customClass="loader-center" />
                    ) : (
                      <AgGridReact
                        defaultColDef={defaultColDef}
                        floatingFilter={true}
                        domLayout="autoHeight"
                        rowData={
                          state.showExtraData && AssesmentMasterList?.data?.Data
                            ? [
                              ...setLoremIpsum(AssesmentMasterList?.data?.Data[0]),
                              ...AssesmentMasterList?.data?.Data,
                            ]
                            : AssesmentMasterList?.data?.Data
                        }
                        pagination={true}
                        paginationPageSize={defaultPageSize}
                        onGridReady={onGridReady}
                        gridOptions={gridOptions}
                        noRowsOverlayComponent="customNoRowsOverlay"
                        noRowsOverlayComponentParams={{
                          title: EMPTY_DATA,
                          imagClass: "imagClass",
                        }}
                        rowSelection="multiple"
                        suppressRowClickSelection={true}
                        onSelectionChanged={onRowSelect}
                        onFilterModified={onFloatingFilterChanged}
                        frameworkComponents={frameworkComponents}
                      >
                        <AgGridColumn
                          cellClass="has-checkbox"
                          field="AssessmentQuestion"
                          sortable={true}
                          unSortIcon={true}
                          filter={true}
                          floatingFilter={true}
                          headerName="Assessment Question"
                          wrapText={true}
                          autoHeight={true}
                          width={480}
                        />
                        <AgGridColumn
                          field="CheckPointGroupName"
                          floatingFilter={true}
                          sortable={true}
                          unSortIcon={true}
                          headerName="Check Point Group"
                          wrapText={true}
                          autoHeight={true}
                        />
                        <AgGridColumn
                          cellClass="hl-categories-cell"
                          headerName="Categories"
                          field="Categories"
                          sortable={false}
                          cellRenderer="renderCategoryCount"
                          autoHeight={true}
                          wrapText={true}
                        />
                        <AgGridColumn
                          headerName="Action"
                          sortable={false}
                          cellRenderer="totalValueRenderer"
                          type="rightAligned"
                          floatingFilter={false}
                          width={110}
                          autoHeight={true}
                          wrapText={true}
                        />
                      </AgGridReact>
                    )}
                    <PaginationWrapper
                      gridApi={state.gridApi}
                      setPage={onPageSizeChanged}
                    />
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </>
      ) : activeTab === "add" ? (
        <AddQuestion setActiveTab={setActiveTab} />
      ) : activeTab === "edit" ? (
        <AddQuestion addQuestionTab={addQuestionTab} setActiveTab={setActiveTab} addQuestionTabGuid={addQuestionTabGuid} />
      ) : (
        activeTab === "review" && <ReviewAssesmentQuestions />
      )}
    </>
  );

}
export default AssesmentMasterListing;
